<template>
  <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">

    <div class="search-warp">
      <el-form :inline="true" label-width="80px">
        <el-form-item label="服务名称" style="width: 230px">
          <el-input v-model="paramSearch.serveName" placeholder="请输入服务名称" style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="服务类型" style="width: 200px">
          <el-select v-model="paramSearch.serveType" placeholder="请选择服务类型" style="width: 120px">
            <el-option
                    v-for="item in serveTypeList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监管部门">
          <TreeSelect size="small"
                      :data="departmentData"
                      clearable
                      width="250px"
                      expandAll
                      ref="deptSingle"
                      :obj="mapKey"
                      checkStrictly
                      @getValue="setDeptSingleMenu">
          </TreeSelect>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchFn">查询</el-button>
          <el-button type="primary" @click="addFn">添加</el-button>
          <el-button type="primary" @click="batchUseFn('1')">批量启用</el-button>
          <el-button type="primary" @click="batchUseFn('0')">批量停用</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="table-con">
      <el-table class="w100 mt20 table" header-row-class-name="table-head"
                row-class-name="cu-p" stripe :data="list" @selection-change="changeFun">
        <el-table-column
                type="selection"
                width="55">
        </el-table-column>
        <!--<el-table-column align="center" label="序号" width="50px">-->
          <!--<template slot-scope="scope">-->
            <!--{{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column align="center" label="服务名称">
          <template slot-scope="scope">
            <div v-text="scope.row.serveName">
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="gcRole" label="服务对象"></el-table-column>
        <el-table-column align="center" prop="gcSubject" label="服务主题"></el-table-column>
        <el-table-column align="center"  prop="serveType" label="服务类型">
          <template slot-scope="scope">
            <span v-if="scope.row.serveType == 0">查询类</span>
            <span  v-if="scope.row.serveType == 1">审批类</span>
          </template>
        </el-table-column>
        <el-table-column align="center"  prop="watchDeptName" label="监管部门"></el-table-column>
        <el-table-column align="center"  prop="createTime" label="创建时间" width="160px"></el-table-column>
        <el-table-column align="center" prop="username" label="创建人"></el-table-column>
        <el-table-column align="center" label="状态" width="140px">
          <template slot-scope="scope">
            <div @click="switchUseFlagFn(scope.row.id,scope.row.useFlag)">
              <el-switch v-if="scope.row.useFlag==1"
                      :value="true"
                       class="switch"
                       active-color="#13ce66"
                       inactive-color="#cccccc"
                      active-text="启用"
                      inactive-text="禁用">
              </el-switch>
              <el-switch v-else
                         class="switch"
                         active-color="#13ce66"
                         inactive-color="#cccccc"
                         active-text="启用"
                         inactive-text="禁用">
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="170px">
          <template slot-scope="scope">
            <div class="to-use">
              <span class="info" @click="useInfoFn(scope.row)">监控</span>
              <span class="info" @click="editFn(scope.row.id)">编辑</span>
              <span class="danger" @click="deleteFn(scope.row.id)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination background @size-change="changeSize"
                     @current-change="changePage"
                     :current-page="paramSearch.current"
                     :page-sizes="pageSizes"
                     :page-size="paramSearch.size"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"
      ></el-pagination>
    </div>

    <!-- 详情、新增 -->
    <ServeDialog ref="serveDialog" @saveSuccess="saveSuccess"/>
    <!-- 服务监控 -->
    <UseServeInfoDialog ref="useServeInfoDialog" />
  </div>
</template>

<script>
    import TreeSelect from "@/components/TreeSelect.vue";
    import ServeDialog from "@/components/management/serve/ServeDialog.vue";
    import UseServeInfoDialog from "@/components/management/serve/useServeInfoDialog.vue";
    import { getServePage,getServeInfo, handleServeDelete,useOrDisuse} from '@/api/managementCenter/serveManage';
    import { getDeptTree} from '@/api/managementCenter/otherApi';

    export default {
        name: "Theme",
        components: {
            TreeSelect,
            ServeDialog,
            UseServeInfoDialog
        },
        props: [],
        data() {
            return {
                selectionChecked:[],
                serveTypeList:[
                    {
                      name:'请选择',
                      value:''
                    },
                    {
                        name:'查询类',
                        value:'0'
                    },
                    {
                        name:'审批类',
                        value:'1'
                    }
                    ],
                departmentData:[],
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
                loading: false,
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10,
                    watchDeptId:'',
                    serveType:'',
                    serveName:''

                },
                total: 0
            };
        },
        computed: {},
        created() {},
        mounted() {
            this.getListFn();
            this.getDeptTreeData();
        },
        methods: {
            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        this.departmentData = data.data
                    }
                }).catch(err=>{

                })
            },
            setDeptSingleMenu(key,data){
                this.paramSearch.watchDeptId=data.id
            },
            // 获取查询列表
            getListFn () {
                this.loading = true;
                getServePage(this.paramSearch).then(({data})=> {
                    this.loading = false;
                    if(data.code == 0){
                        this.selectionChecked=[];
                        this.list = data.data.records || []
                        this.total = data.data.total;
                    }
                })
                    .catch(() => {
                        this.loading = false;
                    });
            },

            // 添加
            addFn() {
                this.$refs.serveDialog.dialogShow('add');
            },

            // 删除
            deleteFn (id) {
                this.$confirm( "是否确定删除?", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteHttp(id)

                }).catch(() => {
                    this.$message.info( "已取消删除" );

                });
            },
            deleteHttp(id){
                this.loading = true;
                // 删除接口
                handleServeDelete(id).then( ({data}) => {
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success( "删除成功!" );
                        this.getListFn();
                    }else{
                        this.$message.warning(data.msg|| "删除失败！" );
                    }
                }).catch(() => {
                    this.loading = false;
                    this.$message.error( "删除异常!" );
                });
            },
            // 详情
            editFn (id) {
                this.loading = true;
                getServeInfo(id).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){

                        this.$refs.serveDialog.dialogShow('edit',data.data);

                    }else{
                        this.$message.warning( data.msg||"获取服务信息失败！" );
                    }
                }).catch(err=>{
                    this.loading = false;
                })


            },
            //监控
            useInfoFn(row){
              this.$refs.useServeInfoDialog.dialogShow(row);
            },

            // 收搜数据
            searchFn() {
                this.paramSearch.current=1
                this.getListFn();
            },

            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            saveSuccess(){
                this.getListFn();
            },
            useOrDisuseFn(params){
                useOrDisuse(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success(data.msg||'操作成功!')
                        this.getListFn();
                    }else{
                        this.$message.warning(data.msg||'操作失败!')
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(data.msg||'操作异常!')
                })

            },
            switchUseFlagFn(id,value){
                let params={
                    serveIds:id,
                    useFlag:value==1?'0':'1'
                }
                this.useOrDisuseFn(params)
            },
            batchUseFn(useFlag){
                if(this.selectionChecked.length==0){
                    this.$message.warning('请选择服务!')
                    return;
                }
                let data=this.selectionChecked.map(i=>i.id);
                let params={
                    serveIds:data.join(','),
                    useFlag
                }
                this.useOrDisuseFn(params)
            },
            changeFun(val) {
                this.selectionChecked=val;
            }
        },
        watch: {},
        filters: {}
    };
</script>


<style scoped  lang="less">
  @import "../../../assets/css/handleBtn.less";
  /deep/.el-table {
    width: 100%;
    .el-table__body-wrapper {
      max-height: calc(100vh - 300px);
      overflow-y: auto;

    }
  }
</style>
<!--修改el-switch 开关样式-->
<style lang="less">
  .el-switch__label {
    position: absolute;
    display: none;
    font-size: 11px !important;
    color: #fff!important;
  }
  .el-switch__label *{
    font-size: 11px !important;
  }
  /*打开时文字位置设置*/
  .el-switch__label--right {
    z-index: 1;
    /*right: -10px; // 这里是重点*/
  top: 0.5px;
  }
  /*关闭时文字位置设置*/
  .el-switch__label--left {
    z-index: 1;
    left: 23px; // 这里是重点
  top: 0.5px;
  }
  /*显示文字*/
  .el-switch__label.is-active {
    display: block;
  }
  .el-switch__core {
    width: 60px ! important;
    height: 22px;
    border: 2px solid #DCDFE6;
    border-radius: 13px;
  }
</style>
